import actionTypes from '../constants/action-types';

const setBlockVariationHTML = (blockId, variationId, html, locale) => ({
  type: actionTypes.SET_BLOCK_VARIATION_HTML,
  payload: {
    blockId,
    variationId,
    html,
    locale,
  },
});

export default setBlockVariationHTML;
